import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  results: [],
  hasMore: true,
};

const paymentHistory = (state = { results: [], hasMore: true }, action) => {
  switch (action.type) {
    case actionTypes.GET_PAYMENT_HISTORY:
      return action.payload;
    case actionTypes.REMOVE_PAYMENT_HISTORY:
      return initialState;
    default:
      return state;
  }
};

export default paymentHistory;
